import { userService } from "../../../services";
import { dateFormatter } from "../../../assets/utils/strings";

export const viewProfileLoader = async () => {

  try {
    const user = await userService.myProfile();

    if (!user) {
      throw new Response("User not found", { status: 404 });
    }
    return user;
  } catch (error) {
    throw new Response(error.message || "Failed to fetch user", { status: 500 });
  }
};

export const updateProfileLoader = async ({ params }) => {
  const { userId } = params;

  try {
    const user = await userService.myProfile(userId);

    if (!user) {
      throw new Response("User not found", { status: 404 });
    }

    const formattedUser = {
      _id:user._id,
      username: user.username || "",
      email: user.email || "",
      phone: user.phone || "",
      gender: user.gender || "",
      dob: user.dob ? dateFormatter(user.dob) : "",
      fullName: {
        fName: user.fullName?.fName || "",
        lName: user.fullName?.lName || "",
      },
      address: {
        street: user.address?.street || "",
        city: user.address?.city || "",
        state: user.address?.state || "",
        postalCode: user.address?.postalCode || "",
        country: user.address?.country || "",
      },
    };

    return formattedUser;
  } catch (error) {
    throw new Response(error.message || "Failed to load user", { status: 500 });
  }
};

